import { Instant } from '@js-joda/core';
import { SecurityPackage } from '@thinkalpha/access-ws-client/contracts/user.js';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config/appConfig';
import type { z } from 'zod';

const axios = createInstance({ baseURL: appConfig.accessApi }, { useLegacySerialization: false });

export async function getUserSecurityPackage(id: string): Promise<z.infer<typeof SecurityPackage>> {
    if (!id) {
        return {
            accessList: [],
            roles: [],
            subscriptions: [],
            expiration: Instant.now(),
        };
    }

    const { data } = await axios.get<unknown>(`/users/${id}/security-package`);
    return SecurityPackage.parse(data);
}

export async function getFirmMemberSecurityPackage(
    firmId: string,
    memberId: string,
): Promise<z.infer<typeof SecurityPackage>> {
    const { data } = await axios.get<unknown>(`/users/${memberId}/security-package`, { params: { firmId } });
    // Default `subscriptions` to `[]` only when missing. The backend always
    // returns it (empty in firm-scoped mode), but this keeps the FE robust
    // during mixed-version deploys where the access-ws change hasn't shipped
    // yet and the response shape might predate the firmId path.
    const raw = (data ?? {}) as Record<string, unknown>;
    const padded = { ...raw, subscriptions: raw.subscriptions ?? [] };
    return SecurityPackage.parse(padded);
}
